import { ClpData } from "../models/Clp";
import axios from "../utils/axios";

export function fetchClp(data: string, token: any) {
  return new Promise<ClpData[]>((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_API_DOMAIN}/check_list_points/`,
        { property: data },
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
